//jshint esversion : 6

import '../styles/Bio.css';

function Bio() {
  return (
    <div className='container-fluid Bio'>
      <div className='container bio-text-container'>
        <h2>Hyy there!!</h2>
        <h4>
          I am Hardik, A pre-final year Computer Science and Engineering student
          from Jaypee Institute of Information technology,Noida,India. I am very
          passionate about any sort of technology. I want to contribute to
          impactful projects to make the world a better place. I have experience
          with MERN stack and Blockchain Development. Feel free to connect with
          me!!
        </h4>
      </div>
    </div>
  );
}

export default Bio;
